import React, { useContext } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Button, Dropdown, Header, Icon } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import { PrivacyModeContext } from "components/PrivacyMode/Context";

import { useAddableWorkflows } from "./hooks/useAddableWorkflows";

function AddClientToWorkflowDropdown({
  client,
  workflows,
  clientWorkflows,
  searchValue,
  loading,
  onAdd,
  onClose,
  onCreateNewWorkflow,
  onWorkflowSelect,
  onSearchValueChange,
}) {
  const { piiMask } = useContext(PrivacyModeContext);
  const [dropdownOpen, openDropdown, closeDropdown] = useBooleanState(false);
  const { options, isEmpty } = useAddableWorkflows(
    client,
    clientWorkflows,
    workflows,
    searchValue
  );

  const create = isEmpty && searchValue?.length > 0;

  return (
    <div>
      <Header as="h3" style={{ marginBottom: "0.5em", display: "inline" }}>
        <Icon name="tasks" />
        Workflows
      </Header>
      <div style={{ marginLeft: "3em" }}>
        <span
          className={piiMask("fs-block dd-privacy-mask")}
          style={{ marginBottom: "0.5em", color: "grey", display: "block" }}
        >
          {`Add ${client.firstName} ${
            client.lastName ? client.lastName : ""
          } to workflow:`}
        </span>
        <Dropdown
          search
          closeOnChange
          selection
          loading={loading}
          disabled={loading && Object.values(workflows).length === 0}
          placeholder="Select a workflow"
          style={{ marginBottom: "0.5em", minWidth: "60%" }}
          onSearchChange={onSearchValueChange}
          searchQuery={searchValue}
          searchInput={{ autoFocus: true }}
          open={dropdownOpen}
          onClose={closeDropdown}
          onOpen={openDropdown}
          data-test="card-workflows-addToWorkflow"
        >
          <Dropdown.Menu>
            {create && (
              <Dropdown.Item onClick={onCreateNewWorkflow}>
                <b>+ Create</b>
                &nbsp;
                {searchValue}
              </Dropdown.Item>
            )}
            {options.map((item) => {
              return (
                <Dropdown.Item
                  key={item.value}
                  onClick={() => {
                    closeDropdown();
                    onWorkflowSelect(item);
                  }}
                >
                  {item.text}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
        <br />
        <Button
          loading={loading}
          positive
          content="Add"
          disabled={create || loading}
          onClick={onAdd}
        />
        <Icon
          name="delete"
          disabled={loading}
          size="large"
          color="grey"
          link
          onClick={onClose}
        />
      </div>
    </div>
  );
}

AddClientToWorkflowDropdown.propTypes = {
  client: PropTypes.object.isRequired,
  clientWorkflows: PropTypes.object,
  workflows: PropTypes.object,
  searchValue: PropTypes.string,
  loading: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateNewWorkflow: PropTypes.func.isRequired,
  onWorkflowSelect: PropTypes.func.isRequired,
  onSearchValueChange: PropTypes.func.isRequired,
};

AddClientToWorkflowDropdown.defaultProps = {
  clientWorkflows: {},
  workflows: {},
  searchValue: "",
  loading: false,
};

const mapStateToProps = () => {
  return (state, props) => {
    return {
      clientWorkflows: state.hubly.data.hub.clientWorkflows,
      workflows: state.hubly.data.hub.workflows,
    };
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddClientToWorkflowDropdown);
